package com.dotdrives.web.pages.updates

import com.dotdrives.controller.NewReportController
import com.dotdrives.controller.UpdatesController
import com.dotdrives.repository.SupabaseReportRepository
import com.dotdrives.web.shell.NavItem
import com.dotdrives.web.shell.PortalShell
import com.dotdrives.web.ui.useFlowState
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.awaitCancellation
import kotlinx.coroutines.cancel
import react.FC
import react.Props
import react.useEffect
import react.useState
import kotlin.time.Clock

private class UpdatesControllerHolder(
    val scope: kotlinx.coroutines.CoroutineScope,
    val updates: UpdatesController,
    val newReport: NewReportController,
)

external interface UpdatesPortalProps : Props {
    var currentUserRole: String
    var orgId: String
    var userId: String
    var userInitials: String
    var userName: String
    var orgName: String
    var canWrite: Boolean
    var onSwitchOrg: () -> Unit
    var onNavigate: (NavItem) -> Unit
    var onSignOut: () -> Unit
}

val UpdatesPortal = FC<UpdatesPortalProps> { props ->
    val (holder) = useState {
        val scope = MainScope()
        val reportRepo = SupabaseReportRepository()
        // Instant.toString() is ISO-8601 ("2026-09-04T..."), so the first four characters are
        // always the calendar year -- avoids pulling kotlinx-datetime into webApp for one field.
        UpdatesControllerHolder(
            scope = scope,
            updates = UpdatesController(reportRepo, scope, props.orgId, props.userId, isStaff = props.canWrite),
            newReport = NewReportController(reportRepo, scope, props.orgId, props.userId),
        )
    }
    val updatesState = useFlowState(holder.updates.state)
    val newReportState = useFlowState(holder.newReport.state)

    useEffect(holder) {
        holder.updates.load()
        try {
            awaitCancellation()
        } finally {
            holder.scope.cancel()
        }
    }

    val delivery = com.dotdrives.web.ui.useWorkflowController(props.userId, props.orgId, props.currentUserRole)
    val deliveryState = useFlowState(delivery.state)
    useEffect(delivery) { delivery.loadJobs() }

    PortalShell {
        active = NavItem.Updates
        onNavigate = props.onNavigate
        userInitials = props.userInitials
        userName = props.userName
        orgName = props.orgName
        onSwitchOrg = props.onSwitchOrg
        onSignOut = props.onSignOut

        UpdatesPage {
            updatesController = holder.updates
            this.updatesState = updatesState
            newReportController = holder.newReport
            this.newReportState = newReportState
            currentUserId = props.userId
            isStaff = props.canWrite
        }
        if (props.currentUserRole != "field") {
            com.dotdrives.web.ui.WorkflowFeedback { controller = delivery; state = deliveryState }
            com.dotdrives.web.ui.DeliveryJobs { controller = delivery; state = deliveryState; sourceId = updatesState.selectedReportId; kinds = listOf("email.report") }
        }
    }
}
